import { lightTheme } from '@/customTheme'
import { CSSProperties, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import SeeAllButton from './SeeAllButton'

interface TitleWithSubActionProps {
  title: string | ReactNode
  subActionText?: string
  onSubActionClick?: () => void
  onTitleClick?: () => void
  disabled?: boolean
  titleStyle?: CSSProperties
  subActionStyle?: CSSProperties
  containerStyle?: CSSProperties
}

function TitleWithSubAction({
  title,
  subActionText = 'See all',
  onSubActionClick,
  onTitleClick,
  disabled = false,
  titleStyle,
  subActionStyle,
  containerStyle,
}: TitleWithSubActionProps) {
  const [t] = useTranslation()

  return (
    <div
      style={{
        height: '26px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '8px',
        ...containerStyle,
      }}
    >
      <p
        style={{
          flex: 1,
          ...lightTheme.typography.Small14Semibold,
          color: lightTheme.colors.text.text_black_title,
          cursor: onTitleClick ? 'pointer' : 'default',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          ...titleStyle,
        }}
        onClick={onTitleClick}
      >
        {typeof title === 'string' ? t(title) : title}
      </p>
      {onSubActionClick && (
        <SeeAllButton
          label={subActionText}
          onClick={onSubActionClick}
          disabled={disabled}
          style={subActionStyle}
        />
      )}
    </div>
  )
}

export default TitleWithSubAction